export const musicPlay = (state) => {
    state.music.file.play()
    state.music.file.loop = true
    state.music.play = true
}

export const musicMute = (state) => {
    state.music.file.pause()
    state.music.play = false
}

export const propModal = (state, met) => {
    state.modals[met.name] = met.bol
}

export const game = (state, func) => {
    state.game[func.prop] = func.val
}